import axios from 'axios';

/**
 * --------------------------------------------------------------- GET Method
 * 获取全部设备
 */
export const getDevices = ({ type, projectId, branchId }) => {
  const params = {};
  if (type) params.type = type;
  if (projectId) params.projectId = projectId;
  if (branchId) params.branchId = branchId;
  return axios.get('/api/devices', { params });
};

// 获取相同sn号的设备，用于应变计组合数据
export const getSameSnDevices = ({ sn }) => {
  return axios.get(`/api/devices/same-sn/${sn}`);
};


/**
 * 获取项目下设备基本状态
 */
export const getDeviceStates = ({ projectId }) => {
  return axios.get(`/api/projects/${projectId}/deviceStates`);
};


/**
 * 获取设备
 */
export const getDevice = (params) => {
  return axios.get(`/api/devices/${params.id}`);
};

/**
 * 获取设备最新状态 deviceState
 */
export const getDeviceState = ({ deviceId }) => {
  return axios.get(`/api/devices/${deviceId}/deviceState`);
};

/**
 * 获取阵列位移计记录器的采集频率
 */
export const getRecTimer = ({ deviceId }) => {
  return axios.get(`/api/devices/${deviceId}/recTimer`);
};

/**
 * 获取阵列位移计校准文件配置
 */
export const getDeviceConfig = (params) => {
  return axios.get(`/api/devices/${params.deviceName}/deviceConfig`);
};

/**
 * 获取『全部阵列位移计』校准文件配置列表
 */
export const getDeviceConfigs = () => {
  return axios.get('/api/devices/deviceConfigs');
};

/**
 * 获取阵列位移计报告模板
 */
export const getDeviceReportField = (params) => {
  return axios.get(`/api/devices/${params.id}/reportField`);
};

/**
 * 获取渗压计探头参数
 */
export const getSYDeviceSetting = (params) => {
  return axios.get(`/api/devices/${params.deviceId}/syDeviceSetting`);
};

/**
 * 获取振动位移计配置参数
 * 工作模式、频率、灵敏度等参数
 */
export const getSdmproSetting = (params) => {
  return axios.get(`/api/devices/${params.deviceId}/sdmproSetting`);
};

/**
 * 获取HDA保持唤醒指令下发剩余时间
 */
export const getHdaSetOnlineRemain = ({ deviceId }) => {
  return axios.get(`/api/devices/${deviceId}/hda-setonline-remain`);
};

/**
 * 获取设备健康的统计图表数据
 */
export const getDeviceMissing = (params) => {
  return axios.get(`/api/devices/${params.deviceId}/startTime/${params.startTime}/endTime/${params.endTime}/device-missing`);
};

/**
 * 检查设备是否有挂起的频率设置任务
 */
export const checkExistSetIntervalJob = ({ deviceId }) => {
  return axios.get(`/api/devices/${deviceId}/check-interval-job`);
};

/**
 * --------------------------------------------------------------- PATCH Method
 * 更新设备
 */
export const updateDevice = (params) => {
  const { deviceId } = params;
  delete params.deviceId;
  return axios.patch(`/api/devices/${deviceId}`, params);
};

/**
 * 更新设备号及网络识别码，用于数采设备替换
 */
export const updateDeviceNameAndRegister = (params) => {
  const { deviceId } = params;
  delete params.deviceId;
  return axios.patch(`/api/devices/${deviceId}/name-register`, params);
};

/**
 * 更新设备报警规则
 */
export const updateDeviceWarningRule = (params) => {
  const { deviceId } = params;
  delete params.deviceId;
  return axios.patch(`/api/devices/${deviceId}/warning-rule`, params);
};

/**
 * --------------------------------------------------------------- POST Method
 * 挂载项目设备
 */
export const mountDevice = (params) => {
  const { projectId } = params;
  delete params.projectId;
  return axios.post(`/api/projects/${projectId}/devices`, params);
};

/**
 * 初始化阵列位移计
 */
export const initDevice = (params) => {
  const { deviceId } = params;
  return axios.post(`/api/devices/${deviceId}/init`);
};

/**
 * 更新设备的初始采集
 */
export const deviceSetinit = (params) => {
  const { deviceId } = params;
  delete params.deviceId;
  return axios.post(`/api/devices/${deviceId}/setinit`, params);
};

/**
 * 更新设备标记点在项目展示图上的坐标
 */
export const updateDeviceMark = (params) => {
  const { deviceId } = params;
  delete params.deviceId;
  return axios.post(`/api/devices/${deviceId}/mark`, params);
};

/**
 * 更新设备分组
 */
export const updateDeviceBranch = (params) => {
  const { deviceId } = params;
  delete params.deviceId;
  return axios.post(`/api/devices/${deviceId}/branch`, params);
};

/**
 * 更新设备经纬度
 */
export const updateDevicePosition = (params) => {
  const { deviceId } = params;
  delete params.deviceId;
  return axios.post(`/api/devices/${deviceId}/position`, params);
};

/**
 * 更新阵列位移计故障节点
 */
export const updateDeviceBadNodes = (params) => {
  const { deviceId } = params;
  delete params.deviceId;
  return axios.post(`/api/devices/${deviceId}/badNodes`, params);
};

/**
 * 更新阵列位移计平滑模型参数
 */
export const updateDeviceSmoothConfig = ({ deviceId, smoothModel, smoothParams }) => {
  return axios.post(`/api/devices/${deviceId}/smoothConfig`, { smoothModel, smoothParams });
};

/**
 * 触发阵列位移计重新平滑数据任务
 */
export const smoothFromInit = ({ deviceId }) => {
  return axios.post(`/api/devices/${deviceId}/smoothFromInit`);
};

/**
 * 触发阵列位移计重新求小时平均数据任务
 */
export const avgFromInit = ({ deviceId }) => {
  return axios.post(`/api/devices/${deviceId}/avgFromInit`);
};

/**
 * 触发阵列位移计重新求小时平均数据任务
 */
export const avgFrom = ({ deviceId, startTime, endTime }) => {
  return axios.post(`/api/devices/${deviceId}/avgFrom`, { startTime, endTime });
};

/**
 * 更新阵列位移计各个节点的扭角
 */
export const setDeviceAzimuth = (params) => {
  return axios.post(`/api/devices/${params.id}/azimuth`, { payload: params.payload });
};

/**
 * 创建阵列位移计抖动修正数据
 */
export const setDeviceJitters = (params) => {
  const { deviceId, startJitterAt, endJitterAt, jitters } = params;
  return axios.post(`/api/devices/${deviceId}/jitters`, { startJitterAt, endJitterAt, jitters });
};

/**
 * 更新阵列位移计报告模板
 */
export const setDeviceReportField = (params) => {
  return axios.post(`/api/devices/${params.id}/reportField`, {
    payload: params.payload,
  });
};

/**
 * 阵列位移计发送记录器指令
 */
export const ctrlDtu = ({ deviceId, cmd, cmdOptions }) => {
  return axios.post(`/api/devices/${deviceId}/command`, { cmd, cmdOptions });
};

/**
 * 重置阵列位移计历史最大变形值
 */
export const resetDeviceDeformation = ({ deviceId }) => {
  return axios.post(`/api/devices/${deviceId}/resetDeformation`);
};

/**
 * 更新振动位移计配置
 * 工作模式、频率、灵敏度等参数
 */
export const updateSdmproMode = (params) => {
  const { deviceId } = params;
  delete params.deviceId;
  return axios.post(`/api/devices/${deviceId}/sdmpromode`, params);
};

/**
 * 发送union协议指令
 */
export const unionCmd = ({ deviceId, cmd, payload }) => {
  return axios.post(`/api/devices/${deviceId}/unionCmd`, { cmd, payload });
};

/**
 * --------------------------------------------------------------- DELETE Method
 * 移除设备
 */
export const deleteDevice = (params) => {
  return axios.delete(`/api/devices/${params.id}`);
};

/**
 * 删除超预警记录
 */
export const deleteWarning = ({ deviceId, ids }) => {
  return axios.post(`/api/devices/${deviceId}/warnings/delete`, { ids });
};

/**
 * 排除设备险情
 */
export const supressDeviceExceed = ({ deviceId }) => {
  return axios.post(`/api/devices/${deviceId}/supress-exceed`);
};

/**
 * 更新组合公式参数
 */
export const updateUnionFormulaParams = ({ type, devicenames, params }) => {
  return axios.post('/api/devices/union-formula-params', { type, devicenames, params });
};

export const updateDeviceAntiDataJump = ({
  deviceId, antiDataJumpSwitch, activeD200Fixer,
}) => {
  return axios.patch(`/api/devices/${deviceId}/anti-data-jump-switch`, {
    antiDataJumpSwitch,
    activeD200Fixer,
  });
};

export const updateDeviceShowProfile = ({
  deviceId, showProfile,
}) => {
  return axios.patch(`/api/devices/${deviceId}/show-profile`, {
    showProfile,
  });
};

/**
 * 更新阵列位移计替换设备
 */
export const updateDeviceReplacedDevice = (params) => {
  const { deviceId } = params;
  delete params.deviceId;
  return axios.post(`/api/devices/${deviceId}/replaced-device`, params);
};
